import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = loc.hash || window.location.hash;
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    const errorParam = params.get("error") || params.get("error_description");

    if (errorParam) {
      // Emergent OAuth or Google itself sent us back with an error param
      toast.error(`Errore Google: ${errorParam}. Riprova o usa email/password.`);
      nav("/login", { replace: true });
      return;
    }

    if (!sessionId) {
      // Provider didn't return session_id → likely an upstream OAuth failure
      toast.error("Login Google non completato. Riprova o usa email/password.");
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        toast.success("Accesso effettuato con Google");
        // strip hash
        window.history.replaceState(null, "", window.location.pathname);
        nav("/feed", { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail;
        const msg = formatApiError(detail);
        toast.error(msg ? msg : "Login Google non riuscito. Riprova o usa email/password.");
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#E11D48] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <div className="label-tag">Accesso in corso...</div>
      </div>
    </div>
  );
}
